import _typeof from '@babel/runtime-corejs3/helpers/typeof';
import _Object$keys from '@babel/runtime-corejs3/core-js-stable/object/keys';
import _bindInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/bind';

function shallowEqual(objA, objB, compare, compareContext) {
  var _context;
  var compareResult = compare ? compare.call(compareContext, objA, objB) : void 0;
  if (compareResult !== void 0) {
    return !!compareResult;
  }
  if (objA === objB) {
    return true;
  }
  if (_typeof(objA) !== 'object' || !objA || _typeof(objB) !== 'object' || !objB) {
    return false;
  }
  var keysA = _Object$keys(objA);
  var keysB = _Object$keys(objB);
  if (keysA.length !== keysB.length) {
    return false;
  }
  var bHasOwnProperty = _bindInstanceProperty(_context = Object.prototype.hasOwnProperty).call(_context, objB);
  // Test for A's keys different from B.
  for (var idx = 0; idx < keysA.length; idx++) {
    var key = keysA[idx];
    if (!bHasOwnProperty(key)) {
      return false;
    }
    var valueA = objA[key];
    var valueB = objB[key];
    compareResult = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
    if (compareResult === false || compareResult === void 0 && valueA !== valueB) {
      return false;
    }
  }
  return true;
}

export { shallowEqual };
